import React from "react";
export const SoonLogo = () => {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M30 16C30 16.34 30 16.67 30 17C29.7667 20.3709 28.3222 23.5436 25.9329 25.9329C23.5436 28.3222 20.3709 29.7667 17 30C16.67 30 16.34 30 16 30C15.66 30 15.33 30 15 30C11.6291 29.7667 8.45636 28.3222 6.0671 25.9329C3.67783 23.5436 2.23329 20.3709 2 17C2 16.67 2 16.34 2 16C2 15.66 2 15.33 2 15C2.23329 11.6291 3.67783 8.45636 6.0671 6.0671C8.45636 3.67783 11.6291 2.23329 15 2C15.33 2 15.66 2 16 2C16.34 2 16.67 2 17 2C20.3709 2.23329 23.5436 3.67783 25.9329 6.0671C28.3222 8.45636 29.7667 11.6291 30 15C30 15.33 30 15.66 30 16Z"
          fill="#f6a51f"
        ></path>{" "}
        <path
          d="M17 28V30C16.67 30 16.34 30 16 30C15.66 30 15.33 30 15 30V28C15 27.7348 15.1054 27.4804 15.2929 27.2929C15.4804 27.1054 15.7348 27 16 27C16.2652 27 16.5196 27.1054 16.7071 27.2929C16.8946 27.4804 17 27.7348 17 28Z"
          fill="#4D4467"
        ></path>{" "}
        <path
          d="M30 16C30 16.34 30 16.67 30 17H28C27.7348 17 27.4804 16.8946 27.2929 16.7071C27.1054 16.5196 27 16.2652 27 16C27 15.7348 27.1054 15.4804 27.2929 15.2929C27.4804 15.1054 27.7348 15 28 15H30C30 15.33 30 15.66 30 16Z"
          fill="#4D4467"
        ></path>{" "}
        <path
          d="M5 16C5 16.2652 4.89464 16.5196 4.70711 16.7071C4.51957 16.8946 4.26522 17 4 17H2C2 16.67 2 16.34 2 16C2 15.66 2 15.33 2 15H4C4.26522 15 4.51957 15.1054 4.70711 15.2929C4.89464 15.4804 5 15.7348 5 16Z"
          fill="#304046"
        ></path>{" "}
        <path
          d="M17 2V4C17 4.26522 16.8946 4.51957 16.7071 4.70711C16.5196 4.89464 16.2652 5 16 5C15.7348 5 15.4804 4.89464 15.2929 4.70711C15.1054 4.51957 15 4.26522 15 4V2C15.33 2 15.66 2 16 2C16.34 2 16.67 2 17 2Z"
          fill="#4D4467"
        ></path>{" "}
        <path
          d="M16 17.0001C15.8088 17.0001 15.6217 16.9453 15.4607 16.8422C15.2997 16.7391 15.1716 16.592 15.0917 16.4184C15.0117 16.2448 14.9831 16.0519 15.0094 15.8625C15.0357 15.6732 15.1157 15.4953 15.24 15.3501L21.24 8.35005C21.3254 8.25025 21.4295 8.16823 21.5466 8.10869C21.6636 8.04915 21.7913 8.01324 21.9222 8.00303C22.0531 7.99282 22.1848 8.00849 22.3097 8.04916C22.4346 8.08983 22.5502 8.15469 22.65 8.24005C22.7498 8.32541 22.8318 8.42959 22.8914 8.54665C22.9509 8.6637 22.9868 8.79134 22.997 8.92227C23.0072 9.0532 22.9916 9.18486 22.9509 9.30973C22.9102 9.43461 22.8454 9.55025 22.76 9.65005L16.76 16.6501C16.6661 16.7598 16.5496 16.8479 16.4184 16.9084C16.2872 16.9688 16.1444 17.0001 16 17.0001Z"
          fill="#4D4467"
        ></path>{" "}
        <path
          d="M16 17H11C10.7348 17 10.4804 16.8946 10.2929 16.7071C10.1054 16.5196 10 16.2652 10 16C10 15.7348 10.1054 15.4804 10.2929 15.2929C10.4804 15.1054 10.7348 15 11 15H16C16.2652 15 16.5196 15.1054 16.7071 15.2929C16.8946 15.4804 17 15.7348 17 16C17 16.2652 16.8946 16.5196 16.7071 16.7071C16.5196 16.8946 16.2652 17 16 17Z"
          fill="#4D4467"
        ></path>{" "}
        <path
          d="M15 2C11.6291 2.23329 8.45636 3.67783 6.0671 6.0671C3.67783 8.45636 2.23329 11.6291 2 15C2 15.33 2 15.66 2 16C2 16.34 2 16.67 2 17C2.23329 20.3709 3.67783 23.5436 6.0671 25.9329C8.45636 28.3222 11.6291 29.7667 15 30C15.33 30 15.66 30 16 30V2C15.66 2 15.33 2 15 2Z"
          fill="#f6a51f"
        ></path>{" "}
        <path
          d="M15 28V30C15.33 30 15.66 30 16 30V27C15.7348 27 15.4804 27.1054 15.2929 27.2929C15.1054 27.4804 15 27.7348 15 28Z"
          fill="#4D4467"
        ></path>{" "}
        <path
          d="M5 16C5 16.2652 4.89464 16.5196 4.70711 16.7071C4.51957 16.8946 4.26522 17 4 17H2C2 16.67 2 16.34 2 16C2 15.66 2 15.33 2 15H4C4.26522 15 4.51957 15.1054 4.70711 15.2929C4.89464 15.4804 5 15.7348 5 16Z"
          fill="#4D4467"
        ></path>{" "}
        <path
          d="M15 2V4C15 4.26522 15.1054 4.51957 15.2929 4.70711C15.4804 4.89464 15.7348 5 16 5V2C15.66 2 15.33 2 15 2Z"
          fill="#4D4467"
        ></path>{" "}
        <path
          d="M15.24 15.35C15.1157 15.4952 15.0357 15.6731 15.0094 15.8624C14.9831 16.0518 15.0117 16.2447 15.0917 16.4183C15.1716 16.592 15.2997 16.739 15.4607 16.8421C15.6217 16.9452 15.8088 17 16 17V14.46L15.24 15.35Z"
          fill="#4D4467"
        ></path>{" "}
        <path
          d="M11 15C10.7348 15 10.4804 15.1054 10.2929 15.2929C10.1054 15.4804 10 15.7348 10 16C10 16.2652 10.1054 16.5196 10.2929 16.7071C10.4804 16.8946 10.7348 17 11 17H16V15H11Z"
          fill="#4D4467"
        ></path>{" "}
      </g>
    </svg>
  );
};
